import { useEffect, useState } from "react";
import "../../assets/scss/intel.scss";
import "../../assets/scss/global.scss";
import LoaderImg from "../../assets/images/loader.gif";
import { globalAPIDictionary } from "../../core/global/global-country-dictionary";
import ReportItem from "./ReportItem";
import "./style.scss";
import DownloadCreditsForm from "./DownloadCreditsForm";
import axios from "axios";
import { useSelector } from "react-redux";

const Reports = (props) => {
  const [currentViewedIndex, setCurrentViewedIndex] = useState(null);
  const [reports, setReports] = useState([]);
  const { userDetails } = useSelector((state) => state);

  const getIndustry = () => {
    switch ((userDetails.userData.industry ?? "").toLowerCase()) {
      case "logistics provider":
        return "logistic";
      case "buyer/ supplier":
        return "buyer_supplier";
      case "others":
        return "other";
      default:
        return "other";
    }
  };

  useEffect(() => {
    const fetchReports = () => {
      const defaultCountryCode = props.defaultData.countryCode.toLowerCase();
      const countryCode = defaultCountryCode === "world" ? "mc" : defaultCountryCode;
      axios.get(`${globalAPIDictionary.getReportsData}?country=${countryCode}&trade_direction=${props.defaultData.countryType}s&industry=${getIndustry()}`).then(({ data: data }) => {
        setReports(data.reports);
      });
    };

    fetchReports();
  }, []);

  const sortByProirity = (a, b) => {
    return a.priority < b.priority;
  };
  return (
    <div className="wrapper">
      {reports?.length > 0 ? (
        <div className="reports-container">
          <p className="reports-heading">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707454796/intel/icons/phy2demx7nst7fmbrbwt.svg" alt="new-release-icon" />
            We surveyed many experts in the industry and carefully compiled these reports for you in one place.
          </p>
          <div className="reports-content">
            <div className="report-items">
              {reports.sort(sortByProirity)?.map((report, index) => (
                <ReportItem report={report} key={report.priority} index={index} analyticsItems={props.analyticsItems} {...props} setCurrentViewedIndex={setCurrentViewedIndex} currentViewedIndex={currentViewedIndex} reportsLength={reports?.length} />
              ))}
            </div>
            <DownloadCreditsForm analyticsCountryID={props.analyticsCountryID} pathname={props.pathname} currentUserPlan={props.currentUserPlan} />
          </div>
        </div>
      ) : (
        <img src={LoaderImg} alt="description of gif" className="loader-img" />
      )}
    </div>
  );
};

export default Reports;
